import type { AxiosError } from 'axios';

import { notifyCloudflareChallenge } from '../cloudflareChallenge';

import isRoverUrl from './isRoverUrl';

export const CF_MITIGATED_HEADER = 'cf-mitigated';

/**
 * Cloudflare answers a challenged XHR with a 403 whose body is the interstitial HTML, which an
 * API caller can only surface as an opaque error. The interstitial can only run in a top-level
 * document, so notify the app, which offers the user a reload.
 */
const handleCloudflareChallenge = (error: AxiosError): Promise<never> => {
  const { response } = error;
  const isChallenge =
    response?.status === 403 &&
    (response.headers as Record<string, unknown> | undefined)?.[CF_MITIGATED_HEADER] ===
      'challenge';
  const method = error.config?.method?.toLowerCase();
  const url = error.config?.url ?? '';

  if (
    isChallenge &&
    typeof window !== 'undefined' &&
    // Reloading Rover can't render a third party's interstitial (Lever job listings).
    isRoverUrl(url) &&
    // A reload discards anything the user has typed, so don't offer one for a failed write.
    method === 'get'
  ) {
    notifyCloudflareChallenge({ url });
  }

  return Promise.reject(error);
};

export default handleCloudflareChallenge;
